import { SET_ALERTS_READ } from "constants-lib/actionTypes"

export const setAlertsRead = (alertsRead) => ({
  type: SET_ALERTS_READ,
  payload: {
    alertsRead,
  },
})
